import { render, staticRenderFns } from "./ProductTabsOne.vue?vue&type=template&id=18564ca6&"
import script from "./ProductTabsOne.vue?vue&type=script&lang=js&"
export * from "./ProductTabsOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports